import React from "react";
import {
  stepCampaignAtom
} from "./entity";
import {
  CampaignThree
} from "./steps/CampaignThree";
import {
  FormProvider,
  useForm
} from "react-hook-form";
import {
  CampaignLookOver
} from "./steps/CampaignLookOver";
import {
  CampaignOne
} from "./steps/CampaignOne";
import {
  CampaignTwo
} from "./steps/CampaignTwo";
import {
  CampaignFour
} from "./steps/CampaignFour";
import {
  useAtomValue
} from "jotai";

export default function CreateCampaign() {
  const stepCampaign =
      useAtomValue(stepCampaignAtom);

  const methods = useForm();

  const currentStep = stepCampaign?.steps ?? 0;

  const renderCurrentStep = () => {
    if (currentStep === 0) return <CampaignOne />;
    if (currentStep === 1) return <CampaignTwo />;
    if (currentStep === 2) return <CampaignThree />;
    if (currentStep === 3) return <CampaignFour />;
    return null;
  };

  return (
      <FormProvider {...methods}>
        {currentStep >= 0 && currentStep <= 3 && renderCurrentStep()}

        {currentStep === 4 && (
            <CampaignLookOver />
        )}
      </FormProvider>
  );
}
